<template>
  <v-card @keydown.esc="$emit('close-dialog')">
    <v-system-bar dark window color="info">
      <v-icon center>mdi-information</v-icon>
      <v-toolbar-title class="ml-1">{{type==='post' ? "Информация о посте" : "Информация о подразделении"}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small icon @click.native="$emit('close-dialog')">
        <v-icon class="mx-0">clear</v-icon>
      </v-btn>
    </v-system-bar>
    
    <v-card-text>
      <v-layout v-if="type==='post'" row wrap>
        <v-flex xs3>
          <v-img :src="data.photo" contain></v-img>
        </v-flex>
        <v-flex xs9 class="px-2">
              <h1 class="headline">{{data.title}}</h1>
              <p class="subheading">{{data.fullname}}</p>
              <div v-if="emails.length>0">
                <b>Адреса электронной почты:</b>
                <ul>
                  <li v-for="email in emails" :key="email.id">{{email.email}}</li>
                </ul>
              </div>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <div v-html="data.description"></div>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap>
        <v-flex xs12>
          <div class="headline">{{data.title}}</div>
          <div v-html="data.description"></div>
        </v-flex>
        <v-flex xs12 v-if="emails.length>0">
          <b>Адреса электронной почты:</b>
          <ul>
            <li v-for="email in emails" :key="email.id">{{email.email}}</li>
          </ul>
        </v-flex>
      </v-layout>
    </v-card-text>
  
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" small @click.native="$emit('close-dialog')">Закрыть</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name : "PostInfo",
    
    props:{
      data:{
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
    
    data(){
      return {
        emails: []
      }
    },
    
    created(){
      this.getPostEmails()
    },
    
    methods:{
      getPostEmails(){
        let data = {
          post_ids: [],
          container_ids: []
        }
        if(this.type==='post'){
          data.post_ids = [this.data.key]
        } else if(this.type==='container'){
          data.container_ids = [this.data.key]
        }
  
        this.$store.dispatch('orgstructure/getEmails', data).then( response => {
          if(this.type==='post'){
            this.emails = response.posts[this.data.key] ? response.posts[this.data.key] : []
          } else if(this.type==='container'){
            this.emails = response.containers[this.data.key] ? response.containers[this.data.key] : []
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Orgschema/Forms/PostInfo.vue